/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Performancetable_Collections_Topwishlisted2Inputs */

const id_components_performancetable_collections_topwishlisted2 = /** @type {(inputs: Components_Performancetable_Collections_Topwishlisted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paling Diinginkan`)
};

const ms_components_performancetable_collections_topwishlisted2 = /** @type {(inputs: Components_Performancetable_Collections_Topwishlisted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paling Diingini`)
};

const da_components_performancetable_collections_topwishlisted2 = /** @type {(inputs: Components_Performancetable_Collections_Topwishlisted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mest ønskede`)
};

const de_components_performancetable_collections_topwishlisted2 = /** @type {(inputs: Components_Performancetable_Collections_Topwishlisted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meistgewünscht`)
};

const en_us2_components_performancetable_collections_topwishlisted2 = /** @type {(inputs: Components_Performancetable_Collections_Topwishlisted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Wishlisted`)
};

const es_es2_components_performancetable_collections_topwishlisted2 = /** @type {(inputs: Components_Performancetable_Collections_Topwishlisted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más deseados`)
};

const es_mx2_components_performancetable_collections_topwishlisted2 = /** @type {(inputs: Components_Performancetable_Collections_Topwishlisted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más deseados`)
};

const fil_components_performancetable_collections_topwishlisted2 = /** @type {(inputs: Components_Performancetable_Collections_Topwishlisted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pinakawishlist`)
};

const fr_components_performancetable_collections_topwishlisted2 = /** @type {(inputs: Components_Performancetable_Collections_Topwishlisted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les plus souhaités`)
};

const it_components_performancetable_collections_topwishlisted2 = /** @type {(inputs: Components_Performancetable_Collections_Topwishlisted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Più desiderati`)
};

const hu_components_performancetable_collections_topwishlisted2 = /** @type {(inputs: Components_Performancetable_Collections_Topwishlisted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legtöbbet kívántak`)
};

const nl_components_performancetable_collections_topwishlisted2 = /** @type {(inputs: Components_Performancetable_Collections_Topwishlisted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meest gewenst`)
};

const no_components_performancetable_collections_topwishlisted2 = /** @type {(inputs: Components_Performancetable_Collections_Topwishlisted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mest ønsket`)
};

const pl_components_performancetable_collections_topwishlisted2 = /** @type {(inputs: Components_Performancetable_Collections_Topwishlisted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najczęściej dodawane do życzeń`)
};

const pt_br2_components_performancetable_collections_topwishlisted2 = /** @type {(inputs: Components_Performancetable_Collections_Topwishlisted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais desejados`)
};

const pt_components_performancetable_collections_topwishlisted2 = /** @type {(inputs: Components_Performancetable_Collections_Topwishlisted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais desejados`)
};

const ro_components_performancetable_collections_topwishlisted2 = /** @type {(inputs: Components_Performancetable_Collections_Topwishlisted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cele mai dorite`)
};

const fi_components_performancetable_collections_topwishlisted2 = /** @type {(inputs: Components_Performancetable_Collections_Topwishlisted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toivotuimmat`)
};

const sv_components_performancetable_collections_topwishlisted2 = /** @type {(inputs: Components_Performancetable_Collections_Topwishlisted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mest önskade`)
};

const vi_components_performancetable_collections_topwishlisted2 = /** @type {(inputs: Components_Performancetable_Collections_Topwishlisted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ưa thích nhất`)
};

const tr_components_performancetable_collections_topwishlisted2 = /** @type {(inputs: Components_Performancetable_Collections_Topwishlisted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En Çok İstenenler`)
};

const cs_components_performancetable_collections_topwishlisted2 = /** @type {(inputs: Components_Performancetable_Collections_Topwishlisted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejvíce přidané do seznamu přání`)
};

const bg_components_performancetable_collections_topwishlisted2 = /** @type {(inputs: Components_Performancetable_Collections_Topwishlisted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Най-желани`)
};

const ru_components_performancetable_collections_topwishlisted2 = /** @type {(inputs: Components_Performancetable_Collections_Topwishlisted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Самое желаемое`)
};

const uk_components_performancetable_collections_topwishlisted2 = /** @type {(inputs: Components_Performancetable_Collections_Topwishlisted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Найбажаніші`)
};

const ar_components_performancetable_collections_topwishlisted2 = /** @type {(inputs: Components_Performancetable_Collections_Topwishlisted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأكثر رغبة`)
};

const hi_components_performancetable_collections_topwishlisted2 = /** @type {(inputs: Components_Performancetable_Collections_Topwishlisted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टॉप विशलिस्टेड`)
};

const th_components_performancetable_collections_topwishlisted2 = /** @type {(inputs: Components_Performancetable_Collections_Topwishlisted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ถูกใจมากที่สุด`)
};

const ja_components_performancetable_collections_topwishlisted2 = /** @type {(inputs: Components_Performancetable_Collections_Topwishlisted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ウィッシュリスト上位`)
};

const zh_cn2_components_performancetable_collections_topwishlisted2 = /** @type {(inputs: Components_Performancetable_Collections_Topwishlisted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`心愿单榜`)
};

const zh_hant1_components_performancetable_collections_topwishlisted2 = /** @type {(inputs: Components_Performancetable_Collections_Topwishlisted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`願望清單榜`)
};

const ko_components_performancetable_collections_topwishlisted2 = /** @type {(inputs: Components_Performancetable_Collections_Topwishlisted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`위시리스트 상위`)
};

/**
* | output |
* | --- |
* | "Top Wishlisted" |
*
* @param {Components_Performancetable_Collections_Topwishlisted2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_performancetable_collections_topwishlisted2 = /** @type {((inputs?: Components_Performancetable_Collections_Topwishlisted2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Performancetable_Collections_Topwishlisted2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_performancetable_collections_topwishlisted2(inputs)
	if (locale === "ms") return ms_components_performancetable_collections_topwishlisted2(inputs)
	if (locale === "da") return da_components_performancetable_collections_topwishlisted2(inputs)
	if (locale === "de") return de_components_performancetable_collections_topwishlisted2(inputs)
	if (locale === "en-US") return en_us2_components_performancetable_collections_topwishlisted2(inputs)
	if (locale === "es-ES") return es_es2_components_performancetable_collections_topwishlisted2(inputs)
	if (locale === "es-MX") return es_mx2_components_performancetable_collections_topwishlisted2(inputs)
	if (locale === "fil") return fil_components_performancetable_collections_topwishlisted2(inputs)
	if (locale === "fr") return fr_components_performancetable_collections_topwishlisted2(inputs)
	if (locale === "it") return it_components_performancetable_collections_topwishlisted2(inputs)
	if (locale === "hu") return hu_components_performancetable_collections_topwishlisted2(inputs)
	if (locale === "nl") return nl_components_performancetable_collections_topwishlisted2(inputs)
	if (locale === "no") return no_components_performancetable_collections_topwishlisted2(inputs)
	if (locale === "pl") return pl_components_performancetable_collections_topwishlisted2(inputs)
	if (locale === "pt-BR") return pt_br2_components_performancetable_collections_topwishlisted2(inputs)
	if (locale === "pt") return pt_components_performancetable_collections_topwishlisted2(inputs)
	if (locale === "ro") return ro_components_performancetable_collections_topwishlisted2(inputs)
	if (locale === "fi") return fi_components_performancetable_collections_topwishlisted2(inputs)
	if (locale === "sv") return sv_components_performancetable_collections_topwishlisted2(inputs)
	if (locale === "vi") return vi_components_performancetable_collections_topwishlisted2(inputs)
	if (locale === "tr") return tr_components_performancetable_collections_topwishlisted2(inputs)
	if (locale === "cs") return cs_components_performancetable_collections_topwishlisted2(inputs)
	if (locale === "bg") return bg_components_performancetable_collections_topwishlisted2(inputs)
	if (locale === "ru") return ru_components_performancetable_collections_topwishlisted2(inputs)
	if (locale === "uk") return uk_components_performancetable_collections_topwishlisted2(inputs)
	if (locale === "ar") return ar_components_performancetable_collections_topwishlisted2(inputs)
	if (locale === "hi") return hi_components_performancetable_collections_topwishlisted2(inputs)
	if (locale === "th") return th_components_performancetable_collections_topwishlisted2(inputs)
	if (locale === "ja") return ja_components_performancetable_collections_topwishlisted2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_performancetable_collections_topwishlisted2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_performancetable_collections_topwishlisted2(inputs)
	return ko_components_performancetable_collections_topwishlisted2(inputs)
});
export { components_performancetable_collections_topwishlisted2 as "components.performanceTable.collections.topWishlisted" }